<template>
    <modal name="remote-yes-or-no-modal"
           :width="`100%`"
           :height="276"
           :min-width="500"
           :min-height="276"
           :pivotX="0.5"
           :pivotY="0.5"
           :delay="100"
           :clickToClose="false"
           @before-open="beforeOpen"
    >
      <vue-scroll>
        <div class="FloatMenu md_overlay md_overlay_0 ">
            <div class="modal modal_0">
                <div
                    class="md_content"
                    :style="`height: ${height}px`"
                >
                    <div class="popup_title pb20">
                    </div>
                    <span class="md_close">
                        <img
                            src="/images/union.svg"
                            alt=""
                            @click="modalClose"
                        >
                    </span>
                    <div class="question" v-if="this.title">{{this.title}}</div>
                    <div class="question" v-else-if="this.question">{{this.question}}</div>
                    <div class="longQuestion" v-else>{{this.longQuestion1}} <br> {{this.longQuestion2}}</div>
                    <div class="yesOrNoBtn">
                        <a class="btn blue btn_basics saveBtn pointer no-drag" @click="yesFunction">
                            {{ $t('status.yes') }}
                        </a>
                        <a class="btn gray btn_basics cancelBtn pointer no-drag" @click="modalClose">
                            {{ $t('status.no') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
      </vue-scroll>
    </modal>
</template>

<script>
export default {
  name: 'yesOrNoModal',
  components: {},
  props: [],
  data() {
    return {
      question: '',
      longQuestion1: '',
      longQuestion2: '',
      function: '',
      funcParam: '',
      title: undefined,
      height: 260,
    }
  },
  methods: {
    modalClose: function () {
      this.question = '';
      this.longQuestion1 = '';
      this.longQuestion2 = '';
      this.function = '';
      this.funcParam = '';
      this.$modal.hide('remote-yes-or-no-modal');
    },
    beforeOpen(event) {
      this.$modal.hide('notification-modal');
      this.title = event.params.title;
      this.height = event.params.height === undefined ? 260 : event.params.height;

      switch (event.params.questionType) {
        case 'save' :
          this.question = this.$t('alert.save_question');
          break;
        case 'delete' :
          this.question = this.$t('alert.delete_question');
          break;
        case 'cancel' :
          this.question = this.$t('alert.cancel_question');
          break;
        case 'logOut' :
          this.question = this.$t('alert.logOut_question');
          break;
        case 'change' :
          this.question = this.$t('alert.change_question');
          break;
        case 'add' :
          this.question = this.$t('alert.add_question');
          break;
        case 'reset' :
          this.question = this.$t('alert.reset_question');
          break;
        case 'reallyDelete' :
          this.longQuestion1 = this.$t('alert.really_delete_question');
          this.longQuestion2 = this.$t('alert.will_not_be_recovered');
          break;
        case 'lang_setting_during_video_call' :
          this.longQuestion1 = this.$t('alert.lang_setting_during_video_call');
          this.longQuestion2 = this.$t('alert.change_question');
          break;
        case 'month_repeat' :
          this.longQuestion1 = this.$t('monthRepeat.dlgTitle');
          this.longQuestion2 = this.$t('alert.save_question');
          break;
        case 'overlap' :
          this.longQuestion1 = this.$t('monthRepeat.overlapMsg01');
          this.longQuestion2 = this.$t('monthRepeat.overlapMsg02');
          break;
        default :
          this.question = this.$t('alert.unexpected_error'); // 거의 가능성 희박
          break;
      }
      if (event.params.funcParam) { // 전달받은 함수가 파라메터가 있는 경우
        this.funcParam = event.params.funcParam;
      }
      this.function = event.params.function;
    },
    yesFunction() {
      if (this.funcParam !== '') { // 전달받은 함수가 파라메터가 있는 경우
        this.function(this.funcParam);
        this.modalClose();
        return
      }
      this.function();
      this.modalClose();
    }
  }
}
</script>
<style lang="scss">
.v--modal-overlay[data-modal="remote-yes-or-no-modal"] {
  .v--modal {
    //top: calc(var(--app-height) / 2 - 148px) !important;
    //left: calc(50% - 240px) !important;
  }

  .md_overlay {
    background: none;
  }

  .question {
    margin: 30px auto 30px;
    color: var(--grey90);
    font-size: 20px;
    font-weight: bold;
    line-height: 1.3;
    text-align: center;
  }

  .longQuestion {
    margin: 15px auto 10px;
    color: var(--grey90);
    font-size: 20px;
    font-weight: bold;
    line-height: 1.5;
    text-align: center;
  }

  .yesOrNoBtn {
    display: flex;

    a {
      margin: 40px 10px 0 10px;
    }
  }

  .v--modal {
    box-shadow: none;
  }

  .md_content {
    width: 500px;
    height: 260px;
  }
}
</style>


